export default "__VITE_ASSET__DOCbOwZr__"